import React from 'react';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react';

// Dropdown — react-bootstrap-compatible compound API on top of Headless UI Menu.
type DivProps = React.HTMLAttributes<HTMLDivElement>;

interface DropdownType extends React.FC<DivProps & { align?: 'start' | 'end' }> {
  Toggle: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: string }>;
  Menu: React.FC<DivProps>;
  Item: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement> & { as?: React.ElementType; href?: string }>;
  Divider: React.FC;
}

export const Dropdown = (({ className = '', children, ...rest }) => (
  <Menu as="div" className={`tw-relative tw-inline-block tw-text-left ${className}`} {...rest}>
    {children}
  </Menu>
)) as DropdownType;

Dropdown.Toggle = ({ className = '', children, ...rest }) => (
  <MenuButton
    className={`tw-inline-flex tw-items-center tw-gap-1 tw-rounded tw-border tw-border-line tw-bg-surface tw-px-3 tw-py-1.5 tw-text-content hover:tw-bg-surface-hover ${className}`}
    {...rest}
  >
    {children}
    <i className="bi bi-caret-down-fill tw-text-xs" />
  </MenuButton>
);

Dropdown.Menu = ({ className = '', children, ...rest }) => (
  <MenuItems
    anchor="bottom start"
    className={`tw-z-[1060] tw-mt-1 tw-min-w-[10rem] tw-rounded tw-border tw-border-line tw-bg-surface tw-py-1 tw-shadow-lg focus:tw-outline-none ${className}`}
    {...rest}
  >
    {children}
  </MenuItems>
);

Dropdown.Item = ({ className = '', as, href, children, ...rest }) => (
  <MenuItem>
    {() => {
      const Comp: React.ElementType = as || (href ? 'a' : 'button');
      return (
        <Comp
          href={href}
          className={`tw-block tw-w-full tw-cursor-pointer tw-px-4 tw-py-2 tw-text-left tw-text-content data-[focus]:tw-bg-surface-hover ${className}`}
          {...rest}
        >
          {children}
        </Comp>
      );
    }}
  </MenuItem>
);

Dropdown.Divider = () => <div className="tw-my-1 tw-border-t tw-border-line" />;

export default Dropdown;
